import React from 'react';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {reduxForm, Field} from 'redux-form';

import {createMember} from 'ducks/users';

import Label from 'components/Label';
import FormField from 'components/FormField';
import ErrorBlock from 'components/ErrorBlock';
import {TextField, EmailField} from 'components/Fields';

import './styles.css';

const formSubmit = (values, dispatch, props) => {
  const {email, fullName} = values;
  const {getExtraActions} = props;

  const data = {
    email,
    fullName
  };

  dispatch(createMember(data, getExtraActions()));
};

class CreateMemberForm extends React.Component<any> {
  render() {
    const {className, handleSubmit, error} = this.props;

    return (
      <form
        onSubmit={handleSubmit}
        className={classNames(className, 'CreateMemberForm')}>
        {error && <ErrorBlock>{error}</ErrorBlock>}
        <FormField>
          <Label>Full Name</Label>
          <Field name="fullName" component={TextField} />
        </FormField>
        <FormField>
          <Label>Email</Label>
          <Field name="email" component={EmailField} />
        </FormField>
      </form>
    );
  }
}

export default connect()(
  reduxForm({form: 'createMember', onSubmit: formSubmit})(CreateMemberForm)
);
